import React, { useEffect } from 'react'
import { Fragment, useState } from 'react'
import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    Transition,
    TransitionChild,
    DialogTitle
} from '@headlessui/react';
import { IoClose, IoCaretDown, IoCheckmarkCircleOutline } from "react-icons/io5";
import { HiOutlineMenu } from "react-icons/hi";
import { Link } from 'react-router-dom';
import { GrLocation } from "react-icons/gr";
import { PiBoxArrowUp, PiCalculatorLight } from "react-icons/pi";
import { ApolloConsumer, useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useFormik } from "formik";
import { handleLogin } from '../Common/TokenLogin.js';
import SpinLoader from '../components/SpinLoader.js';
import { GET_ADVERTISE } from '../graphql/Query/Advertise.js';
import { GET_TOPBAR } from '../graphql/Query/TopBar.js';
import { useModal } from '../Contex.js';
import { MdDirectionsBike } from 'react-icons/md';
import { BsBox } from 'react-icons/bs';
import axios from 'axios';
import { COURIER_PASSWORD, COURIER_USERNAME, RETURN_URL, RETURN_URL_Wallet } from '../config.js';
import { LuCalculator, LuPlaneTakeoff } from 'react-icons/lu';
import { FaCirclePlus } from "react-icons/fa6";
import { FiPlusCircle } from "react-icons/fi";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { CiCalculator2 } from "react-icons/ci";
import { FaCheckCircle, FaSearchLocation, FaSyncAlt, FaTimesCircle } from "react-icons/fa";
import { TbCurrentLocation } from "react-icons/tb";
import { CREATE_RECHARGE } from '../graphql/Mutation/Wallet.js';
import { cashfree } from '../utils/CashFreePayment.js';
import { GET_WALLET_BALANCE } from '../graphql/Query/Wallet.js';

const navigation = {
    categories: [
        {
            id: 'Ships',
            name: 'Ships',
            featured: [
                {
                    name: 'Ship Now',
                    href: '/documentshipping',
                    imageSrc: "https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/couriernow.jpg",
                    imageAlt: 'Models sitting back to back, wearing Basic Tee in black and bone.',
                },
                {
                    name: 'Get Shipment Estimate',
                    href: '/calculatorcourier',
                    imageSrc: "https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/caldad.jpg",
                    imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
                },
            ],
            sections: [
                {
                    id: 'Ship now',
                    name: 'Ship now  ',
                    items: [
                        { name: 'Document Express Delivery', href: '/documentshipping', state: { key: false } },
                        { name: 'Lightweight (0-30Kg) Shipping', href: '/documentshipping', state: { key: true } },
                        { name: 'Bulk Shipping (0-30Kg) ', href: '/bulkcourier', state: { key: true } },
                        // { name: 'Same Day Shipment', href: '/sameday' },
                        { name: 'Worldwide (Global) Shipping', href: '/foreignair' },
                    ],
                },
                {
                    id: 'Get Shipment Estimate',
                    name: 'Get Shipment Estimate',
                    items: [
                        { name: 'Document Express Delivery', href: '/calculatorcourier', state: { keyy: false } },
                        { name: 'Lightweight (0-30Kg) Shipping', href: '/calculatorcourier', state: { keyy: true } },
                        { name: 'Bulk Shipping (0-30Kg) ', href: '/calculatorcourier', state: { key: true } },
                        // { name: 'Same day Shipment', href: '/sameday' },
                        { name: 'Worldwide (Global) Shipping', href: '/foreignair' },
                    ],
                },
                {
                    id: 'Domestic Shipping',
                    name: 'Domestic Shipping',
                    items: [
                        { name: 'All Domestic Shipments', href: '/allOrders', state: { data: 'All Courier' } },
                        { name: 'Incoming Shipments (To Me - Domestic)', href: '/allOrders', state: { data: 'To me' } },
                        { name: 'Outgoing Shipments (From Me - Domestic)', href: '/allOrders', state: { data: 'From me' } },
                        { name: 'Track & Locate Shipments', href: '/trackcourier' },
                    ],
                },
            ],
        },
        {
            id: 'Accounts',
            name: 'Accounts',
            featured: [
                {
                    name: 'Label & Packaging Guidelines',
                    href: '/packguidlines',
                    imageSrc: "https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/invalidbox2.png",
                    imageAlt: 'Models sitting back to back, wearing Basic Tee in black and bone.',
                },
                {
                    name: 'Prohibited & Restricted Items',
                    href: '/retrictedItem',
                    imageSrc: "https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/invalidbox1.png",
                    imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
                },
            ],
            sections: [
                {
                    id: 'Account & Lists',
                    name: 'Account & Lists',
                    items: [
                        { name: 'Help & Support', href: '/accordionhelp' },
                        { name: 'Contact Us & Enquiry Now', icon: 'GrLocation', href: '/anotherhelp' },
                        { name: 'Update Profile', href: '/settings' },
                    ],
                },
                {
                    id: 'Shipping Guidelines',
                    name: 'Shipping Guidelines',
                    items: [
                        { name: 'Labeling Instructions', href: '/shippinglabel' },
                        { name: 'Packaging Standards', href: '/packguidlines' },
                        { name: 'Prohibited & Restricted Items', href: '/retrictedItem' },
                    ],
                },
                {
                    id: 'Shipping Policies',
                    name: 'Shipping Policies',
                    items: [
                        { name: 'Privacy Policy', href: '/privacyPolicy' },
                        { name: 'Terms & Conditions', href: '/termsAndConditions' },
                        { name: 'Cookie Policy', href: '/cookiespolicy' },
                        { name: 'Fraud Disclaimer', href: '/fraudDisclaimer' },
                    ],
                },
            ],
        },
    ],
    pages: [
        { name: 'Notification', href: '/notification' },
        // { name: 'Support', href: '/accordionhelp' },
        // { name: 'Tracking ', href: '/trackcourier' },
    ],
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Header = () => {
    const [rechargeWallet] = useMutation(CREATE_RECHARGE);
    const { data: walletData } = useQuery(GET_WALLET_BALANCE, {
        fetchPolicy: "cache-and-network"
    });
    // console.log('✌️walletDta --->', walletData?.GetWalletBalanceAmount?.balance);
    const { setModalOpen } = useModal();
    const [open, setOpen] = useState(false)
    const [openSideMenu, setOpenSideMenu] = useState(false)
    const [message, setMessage] = useState('');
    const [page] = useState(0);
    const [limit] = useState(10);
    const [countNotification, setCountNotification] = useState();
    const token = localStorage.getItem('token');
    const [amount, setAmount] = useState(500);
    const amounts = [500, 1000, 2000, 5000, 10000];
    const signOut = (client) => {
        localStorage.clear()
        sessionStorage.clear();
        client.resetStore();
        toast.success("user logged out successfully!", {
            autoClose: 2000
        })
    };

    const { data } = useQuery(GET_TOPBAR);
    const [openPincode, setOpenPincode] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    let lastScrollY = 0;


    const validationSchema = Yup.object({
        origin: Yup.string().required('Pincode is required')
            .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits'),
        destination: Yup.string().required('Pincode is required')
            .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits'),
    });

    const initialValues = {
        origin: '',
        destination: '',
        payment_type: 'prepaid',
    };

    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const authToken = await handleLogin();

            const response = await axios.post(
                'https://shipment.xpressbees.com/api/courier/serviceability',
                values,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                }
            );

            const data = response?.data;

            if (!data?.status) {
                // setMessage(data?.data);      //when show only expressbess api
                const originResponse = await axios.post(
                    "https://api.ecomexpress.in/apiv3/pincode/",
                    {
                        username: COURIER_USERNAME,
                        password: COURIER_PASSWORD,
                        pincode: values?.origin,
                    },
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    }
                );

                const destinationResponse = await axios.post(
                    "https://api.ecomexpress.in/apiv3/pincode/",
                    {
                        username: COURIER_USERNAME,
                        password: COURIER_PASSWORD,
                        pincode: values?.destination,
                    },
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    }
                );

                // console.log('✌️Origin Response --->', originResponse?.data);
                // console.log('✌️Destination Response --->', destinationResponse?.data);

                const isOriginAvailable =
                    originResponse?.status === 200 &&
                    Array.isArray(originResponse?.data) &&
                    originResponse?.data?.length > 0 &&
                    originResponse.data[0].status !== 0;

                const isDestinationAvailable =
                    destinationResponse?.status === 200 &&
                    Array.isArray(destinationResponse?.data) &&
                    destinationResponse?.data?.length > 0 &&
                    destinationResponse.data[0].status !== 0;

                if (isOriginAvailable && isDestinationAvailable) {
                    setMessage("Pincode Service Available");
                } else {
                    setMessage(data?.data);
                }
            } else {
                setMessage("Pincode Service Available");
            }
        } catch (error) {
            toast.error(error?.message)
        } finally {
            setIsLoading(false);
        }
    };
    const closeEventData = () => {
        setOpenPincode(false);
        setMessage('');
    }
    const { data: getAdvertise } = useQuery(GET_ADVERTISE, {
        variables: {
            page: page + 1,
            limit,
            sort: {
                key: "createdAt",
                type: -1
            },
        }
    });
    useEffect(() => {
        const unreadNotificationsCount = getAdvertise?.getBlogs?.data.filter(blog => !blog?.readStatus).length;
        setCountNotification(unreadNotificationsCount);
    }, [getAdvertise]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > lastScrollY) {
                setIsVisible(false); // Hide on scroll down
            } else {
                setIsVisible(true); // Show on scroll up
            }
            lastScrollY = window.scrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // Function to toggle dropdown visibility
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const [isOpenAllCourier, setIsOpenAllCourier] = useState(false);

    // Function to toggle dropdown visibility
    const DropdownCouriers = () => {
        setIsOpenAllCourier(!isOpenAllCourier);
    };



    const handleClick = () => {
        setShowTooltip(!showTooltip);
    };

    const formik = useFormik({
        initialValues: {
            amount: "",
        },
        validationSchema: Yup.object({
            amount: Yup.number()
                .required("Amount is required")
                .positive("Amount must be positive")
                .min(1, "Amount must be greater than zero"),
        }),
        onSubmit: async (values) => {
            try {
                const response = await rechargeWallet({ variables: { amount: parseFloat(values?.amount) } });
                // console.log('✌️response --->', response);

                if (response.data?.RechargeWalletBalance?.success) {
                    const paymentSessionId = response.data?.RechargeWalletBalance?.paymentSessionId
                    const checkoutOptions = {
                        paymentSessionId,
                        "return_url": RETURN_URL_Wallet,
                        redirectTarget: "_self",
                    };
                    cashfree.checkout(checkoutOptions)
                } else {
                    toast.error(response.data?.RechargeWalletBalance?.message || "Recharge failed");
                }
            } catch (error) {
                console.error("Mutation error:", error);
                toast.error("Error processing the recharge");
            }
            // setSubmitting(false);
        },
    });
    return (
        <div className="bg-white  sticky top-0 w-full z-50">
            <Transition show={open}>
                <Dialog className="relative z-50 lg:hidden" onClose={setOpen}>
                    <TransitionChild
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </TransitionChild>

                    <div className="fixed inset-0 z-50 flex">
                        <TransitionChild
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <DialogPanel className="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
                                <div className="flex px-4 pb-2 pt-5">
                                    <button
                                        type="button"
                                        className="relative -m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Close menu</span>
                                        <IoClose className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                </div>

                                {/* Links */}
                                <TabGroup className="mt-2">
                                    <div className="border-b border-gray-200">
                                        <TabList className="-mb-px flex space-x-8 px-4">
                                            {navigation.categories.map((category) => (
                                                <Tab
                                                    key={category.name}
                                                    className={({ selected }) =>
                                                        classNames(
                                                            selected ? 'border-black text-black' : 'border-transparent text-gray-900',
                                                            'flex-1 whitespace-nowrap border-b-2 px-1 py-4 text-base font-medium'
                                                        )
                                                    }
                                                >
                                                    {category.name}
                                                </Tab>
                                            ))}
                                        </TabList>
                                    </div>
                                    <TabPanels as={Fragment}>
                                        {navigation.categories.map((category) => (
                                            <TabPanel key={category.name} className="space-y-10 px-4 pb-8 pt-10">
                                                <div className="grid grid-cols-2 gap-x-4">
                                                    {category.featured.map((item) => (
                                                        <div key={item.name} className="group relative text-sm">
                                                            <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-slate-100 group-hover:opacity-75">
                                                                <img src={item.imageSrc} alt={item.imageAlt} className="object-cover object-center" />
                                                            </div>
                                                            <Link to={item.href} className="mt-6 block font-medium text-start text-gray-900">
                                                                <span className="absolute inset-0 z-10" aria-hidden="true" />
                                                                {item.name}
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                                {category.sections.map((section) => (
                                                    <div key={section.name}>
                                                        <p id={`${category.id}-${section.id}-heading-mobile`} className="font-medium text-gray-900">
                                                            {section.name}
                                                        </p>
                                                        <ul
                                                            role="list"
                                                            aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                                                            className="mt-6 flex flex-col space-y-6"
                                                        >
                                                            {section.items.map((item) => (
                                                                <li key={item.name} className="flow-root">
                                                                    <Link to={item.href} state={item.state} className="-m-2 block p-2 text-gray-500" onClick={(e) => {
                                                                        if (item?.name === 'Edit Profile') {
                                                                            e.preventDefault(); // Prevents the default link behavior
                                                                            setModalOpen(true); // Opens the modal
                                                                        }
                                                                        setOpen(false);
                                                                    }}>
                                                                        {item.name}
                                                                    </Link>
                                                                </li>

                                                            ))}
                                                        </ul>
                                                    </div>

                                                ))}



                                                <div className="relative inline-block space-y-4">
                                                    <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/play1.png" alt="" className='h-14 cursor-pointer' onClick={handleClick} />
                                                    <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/applef.png" className='h-14 cursor-pointer' alt="" onClick={handleClick} />

                                                    {showTooltip && (
                                                        <div className="absolute top-full mt-2 w-48 bg-slate-800 text-white text-sm rounded-lg shadow-lg p-2">
                                                            Our application is currently undergoing essential maintenance to bring you new features, improvements, and a better overall experience.
                                                        </div>
                                                    )}
                                                </div>

                                            </TabPanel>

                                        ))}

                                    </TabPanels>
                                </TabGroup>

                                <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                                    {navigation.pages.map((pageData) => (
                                        <div key={pageData.name} className="flow-root">
                                            <Link to={pageData.href}   {...(pageData.name === 'Notification' && {
                                            })} className="-m-2 block p-2 font-medium text-gray-900">
                                                {pageData.name}
                                                {pageData.name === 'Notification' && countNotification > 0 && (
                                                    <span className="ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">
                                                        {countNotification}
                                                    </span>
                                                )}
                                            </Link>
                                        </div>
                                    ))}
                                    <div className=" lg:ml-8 mt-6 lg:flex cursor-pointer" onClick={() => { setOpenPincode(true); setOpen(false); }}>
                                        <div className="flex items-center text-base font-medium text-gray-900">
                                            <GrLocation className='text-lg text-gray-600' />
                                            <span className="ml-1 block">Check Pincode</span>
                                        </div>
                                    </div>

                                    <div className=" lg:ml-8 mt-6 lg:flex cursor-pointer" state={{ key: false }}>
                                        <Link to='/documentshipping'> <div className="flex items-center text-base font-medium text-gray-900">
                                            <FiPlusCircle className='text-lg text-gray-600' />
                                            <span className="ml-1 block">Create Shipment</span>
                                        </div></Link>
                                    </div>

                                    <div className=" lg:ml-8 mt-6 lg:flex cursor-pointer">
                                        <Link to='/calculatorcourier'> <div className="flex items-center text-base font-medium text-gray-900">
                                            <LuCalculator className='text-lg text-gray-600' />
                                            <span className="ml-1 block">Rate Calculator</span>
                                        </div></Link>
                                    </div>
                                    <div className=" lg:ml-8 mt-6 lg:flex cursor-pointer">
                                        <Link to='/trackcourier'> <div className="flex items-center text-base font-medium text-gray-900">
                                            <TbCurrentLocation className='text-lg text-gray-600' />
                                            <span className="ml-1 block">Track AWB</span>
                                        </div></Link>
                                    </div>
                                </div>




                                <div className="border-t border-gray-200 px-4 py-6">
                                    {!token && <div>
                                        <Link to="/signup" className=" text-base font-medium text-gray-900">
                                            <p>
                                                Sign in
                                            </p>
                                        </Link>
                                        <Link to="/signup" className=" text-base font-medium text-gray-900">
                                            <p className='my-6'>
                                                Create account
                                            </p>
                                        </Link>
                                    </div>}
                                    {token &&
                                        <div className='' >
                                            <div className="flow-root">
                                                <ApolloConsumer>
                                                    {client => (
                                                        <Link to="/signup" onClick={() => signOut(client)} className="  text-base font-medium text-gray-900">
                                                            Log out
                                                        </Link>
                                                    )}
                                                </ApolloConsumer>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </Dialog>
            </Transition>
            <header className="relative bg-white z-40">
                {data?.getTopBar?.content &&
                    <p className="flex h-16 md:h-10 items-center justify-center bg-slate-900 px-4 text-sm font-medium text-white sm:px-6 lg:px-8">
                        {data?.getTopBar?.content}
                    </p>
                }

                <nav aria-label="Top" className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                    <div className="border-b border-gray-200">
                        <div className="flex h-16 items-center justify-between">
                            <button
                                type="button"
                                className="relative rounded-md bg-white p-2 text-gray-400 lg:hidden"
                                onClick={() => setOpen(true)}
                            >
                                <span className="absolute -inset-0.5" />
                                <span className="sr-only">Open menu</span>
                                <HiOutlineMenu className="h-6 w-6 self-center" aria-hidden="true" />
                            </button>

                            {/* Logo */}
                            <Link to='/'>
                                <div className="ml-4 flex lg:ml-0">
                                    <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/logo1.png" className="h-8 w-auto" alt="Logo" />
                                    <span className="self-center text-xl font-bold ms-2 ">UK</span>
                                </div>
                            </Link>

                            {/* <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6"> */}
                            {/* <Link to="/signup" className="text-sm font-medium text-gray-700 hover:text-gray-800 lg:hidden block xl:block">
                                        Sign in
                                    </Link>
                                    <span className="h-6 w-px bg-slate-200" aria-hidden="true" /> */}

                            {/* </div> */}

                            {/* <Link to="/" className="items-center text-sm hidden lg:block font-semibold text-gray-700 hover:text-gray-800 ml-8"
                            >
                                Home
                            </Link> */}

                            <PopoverGroup className="hidden lg:ml-8 lg:block lg:self-stretch">
                                <div className="flex h-full space-x-5 xl:space-x-8">
                                    {navigation.categories.map((category) => (
                                        <Popover key={category.name} className="flex">
                                            {({ open }) => (
                                                <>
                                                    <div className="relative flex">
                                                        <PopoverButton
                                                            className={classNames(
                                                                open
                                                                    ? 'border-black text-black'
                                                                    : 'border-transparent text-gray-700 hover:text-gray-800',
                                                                'relative z-10 -mb-px flex items-center border-b-2 pt-px text-sm font-medium transition-colors duration-200 ease-out'
                                                            )}
                                                        >
                                                            {category.name}
                                                        </PopoverButton>
                                                    </div>

                                                    <Transition
                                                        enter="transition ease-out duration-200"
                                                        enterFrom="opacity-0"
                                                        enterTo="opacity-100"
                                                        leave="transition ease-in duration-150"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <PopoverPanel className="absolute inset-x-0 top-full text-sm text-gray-500">
                                                            <div className="absolute inset-0 top-1/2 bg-white shadow" aria-hidden="true" />
                                                            <div className="relative bg-white">
                                                                <div className="mx-auto max-w-auto px-8 bg-white">
                                                                    <div className="grid grid-cols-2 gap-x-8 gap-y-10 py-16 bg-white">
                                                                        <div className="col-start-2 grid grid-cols-2 gap-x-8">
                                                                            {category.featured.map((item) => (
                                                                                <div key={item.name} className="group relative text-base sm:text-sm">
                                                                                    <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-slate-100 group-hover:opacity-75">
                                                                                        <img
                                                                                            src={item.imageSrc}
                                                                                            alt={item.imageAlt}
                                                                                            className="object-cover object-center"
                                                                                        />
                                                                                    </div>
                                                                                    <Link to={item.href} className="mt-6 block text-start font-medium text-gray-900">
                                                                                        <span className="absolute inset-0 z-10" aria-hidden="true" />
                                                                                        {item.name}
                                                                                    </Link>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        <div className="row-start-1 grid grid-cols-3 gap-x-8 gap-y-10 text-sm">
                                                                            {category.sections.map((section) => (
                                                                                <div key={section.name}>
                                                                                    <p id={`${section.name}-heading`} className="font-medium text-start text-gray-900">
                                                                                        {section.name}
                                                                                    </p>
                                                                                    <ul
                                                                                        role="list"
                                                                                        aria-labelledby={`${section.name}-heading`}
                                                                                        className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
                                                                                    >
                                                                                        {section.items.map((item) => (
                                                                                            <li key={item.name} className="flex">
                                                                                                <Link to={item.href} state={item.state} className="hover:text-gray-800" onClick={(e) => {
                                                                                                    if (item?.name === 'Edit Profile') {
                                                                                                        e.preventDefault();
                                                                                                        setModalOpen(true);
                                                                                                    }
                                                                                                    setOpen(false);
                                                                                                }}>
                                                                                                    {item.name}
                                                                                                </Link>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            ))}

                                                                            <div className="relative inline-block">
                                                                                <div className='flex space-x-4'>
                                                                                    <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/play1.png" alt="" className='cursor-pointer' onClick={handleClick} />
                                                                                    <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/applef.png" className='h-13 cursor-pointer' alt="" onClick={handleClick} />

                                                                                    {showTooltip && (
                                                                                        <div className="absolute top-full w-48 bg-slate-800 text-white text-sm rounded-lg shadow-lg p-2">
                                                                                            Our application is currently undergoing essential maintenance to bring you new features, improvements, and a better overall experience.
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </PopoverPanel>
                                                    </Transition>
                                                </>
                                            )}
                                        </Popover>
                                    ))}

                                    {navigation.pages.map((pageData) => (
                                        <Link
                                            key={pageData.name}
                                            to={pageData.href}
                                            {...(pageData.name === 'Notification' && {
                                            })}
                                            className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"
                                        >
                                            {pageData.name}
                                            {pageData.name === 'Notification' && countNotification > 0 && (
                                                <span className="ml-1 inline-flex items-center justify-center px-1.5 py-1 text-xs font-bold leading-none text-white bg-slate-800 rounded-full">
                                                    {countNotification}
                                                </span>
                                            )}
                                        </Link>
                                    ))}
                                </div>

                            </PopoverGroup>
                            {/* <div className="relative hidden lg:ml-8 lg:flex cursor-pointer me-2">
                                <div
                                    className="flex items-center text-gray-700 hover:text-gray-800 relative"
                                    onClick={toggleDropdown}
                                >
                                    <span className="ml-1 block text-sm font-medium">Courier Now
                                    </span><IoCaretDown className='mt-1' />
                                </div>

                                {isDropdownOpen && (
                                    <div className="absolute left-0 top-5 mt-5 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50">
                                        <ul className="py-2">
                                            <li>
                                                <Link
                                                    to="/documentshipping"
                                                    className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    state={{ key: false }}
                                                >
                                                    Letter, Document Courier
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/documentshipping"
                                                    className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    state={{ key: true }}
                                                >
                                                    Domestic Courier
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/bulkcourier"
                                                    className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    state={{ key: true }}
                                                >
                                                    Domestic Bulk Courier
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/sameday"
                                                    className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    state={{ key: true }}
                                                >
                                                    In-City Bike Courier
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to={false ? "/foreignair" : null} 
                                                    className={`block px-4 py-2 text-sm font-medium ${false ? "text-gray-700 hover:bg-slate-100" : "text-gray-400 cursor-not-allowed"
                                                        }`}
                                                    onClick={(e) => false && e.preventDefault()} 
                                                >
                                                    International Courier
                                                </Link>
                                            </li>

                                        </ul>
                                    </div>
                                )}
                            </div> */}


                            <div className="lg:ml-9 xl:ml-auto ml-auto flex items-center">
                                {/* {!token && <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6">
                                    <Link to="/signup" className="text-sm font-medium text-gray-700 hover:text-gray-800">
                                        Create account
                                    </Link>
                                </div>}
                                {token &&
                                    <div className='hidden md:block' >
                                        <div className="flow-root">
                                            <ApolloConsumer>
                                                {client => (
                                                    <Link to="/signup" onClick={() => signOut(client)} className=" block text-sm font-medium text-gray-700 group-hover:text-gray-800">
                                                        LogOut
                                                    </Link>
                                                )}
                                            </ApolloConsumer>
                                        </div>
                                    </div>
                                } */}


                                <div className="hidden md:block lg:ml-8 cursor-pointer" state={{ key: false }}>
                                    <Link to="/documentshipping" className="flex flex-col items-center text-gray-700 hover:text-gray-800">
                                        <FiPlusCircle className="text-gray-600 text-lg mb-1" />
                                        <span style={{ fontSize: "13px", fontWeight: 500 }} className='text-gray-600'>
                                            Create Shipment
                                        </span>
                                    </Link>
                                </div>

                                <div className="hidden md:block lg:ml-8 md:mx-7 lg:mx-0 cursor-pointer">
                                    <Link to="/calculatorcourier" className="flex flex-col items-center text-gray-700 hover:text-gray-800">
                                        <LuCalculator className="text-gray-600 text-lg mb-1" />
                                        <span style={{ fontSize: "13px", fontWeight: 500 }} className='text-gray-600'>
                                            Rate Calculator
                                        </span>
                                    </Link>
                                </div>

                                <div className="hidden xl:block lg:ml-8 cursor-pointer">
                                    <Link to="/trackcourier" className="flex flex-col items-center text-gray-700 hover:text-gray-800">
                                        <TbCurrentLocation className="text-gray-600 text-lg mb-1" />
                                        <span style={{ fontSize: "13px", fontWeight: 500 }} className='text-gray-600'>
                                            Track AWB
                                        </span>
                                    </Link>
                                </div>

                                <div className="lg:ml-8 xl:block hidden  cursor-pointer" onClick={() => setOpenPincode(true)}>
                                    <div className="flex flex-col items-center text-gray-700 hover:text-gray-800">
                                        <GrLocation className="text-gray-600 text-lg mb-1" />
                                        <span style={{ fontSize: "13px", fontWeight: 500 }} className='text-gray-600'>Check Pincode</span>
                                    </div>
                                </div>

                                {/* <div className="flex items-center space-x-1">
                                            <MdOutlineAccountBalanceWallet className="text-gray-500 text-xl" />
                                            <p className="text-[16px] font-semibold">26777.96</p>
                                            <p className="text-[13px] font-medium text-gray-600">INR</p>
                                        </div> */}
                                <div className="hidden md:block bottom-0 sticky lg:ml-8 cursor-pointer px-3 py-2 border-x border-slate-200 transition">
                                    <div className="flex flex-col items-center text-gray-700 hover:text-gray-900">
                                        {token ? <div className="flex items-center space-x-2" onClick={() => setOpenSideMenu(true)}>
                                            <div className="flex flex-col">
                                                <div className="flex items-center justify-center space-x-2">
                                                    {/* <MdOutlineAccountBalanceWallet className="text-gray-600 text-lg" /> */}
                                                    <div className="flex items-center space-x-1">
                                                        <p className="text-[16px]  font-semibold">₹{walletData?.GetWalletBalanceAmount?.balance ? Number(walletData?.GetWalletBalanceAmount?.balance.toFixed(2)) : "0.00"}</p>
                                                        {/* <p className="text-[13px] font-medium">INR</p> */}
                                                    </div>
                                                </div>

                                                <p className="text-[13px] text-blue-600">Wallet Balance</p>
                                            </div>
                                        </div>
                                            : <>
                                                <Link to="/signup">
                                                    <div className="flex flex-col items-center space-y-1">
                                                        <p className="text-blue-600 font-semibold text-sm">Create Account</p>
                                                        <span className="text-[13px] font-medium text-gray-500 text-center">UK Logistics</span>
                                                    </div>
                                                </Link>
                                            </>}
                                    </div>
                                </div>



                                <div className={`fixed md:hidden block bottom-0 left-1/2 transform -translate-x-1/2 w-full md:static md:w-auto lg:ml-8 cursor-pointer px-3 py-2 border-x border-slate-200 transition-all bg-white duration-300 ${isVisible ? "opacity-100" : "opacity-0 translate-y-10"
                                    }`}>
                                    <div className="flex flex-col items-center text-gray-700 hover:text-gray-900">
                                        {token ? <div className="flex items-center space-x-2" onClick={() => setOpenSideMenu(true)}>
                                            <div className="flex flex-col">
                                                <div className="flex items-center justify-center space-x-2">
                                                    {/* <MdOutlineAccountBalanceWallet className="text-gray-600 text-lg" /> */}
                                                    <div className="flex items-center space-x-1">
                                                        <p className="text-[16px]  font-semibold">₹{walletData?.GetWalletBalanceAmount?.balance ? Number(walletData?.GetWalletBalanceAmount?.balance.toFixed(2)) : "0.00"}</p>
                                                        {/* <p className="text-[13px] font-medium">INR</p> */}
                                                    </div>
                                                </div>

                                                <p className="text-[13px] text-blue-600">Wallet Balance</p>
                                            </div>
                                        </div>
                                            : <>
                                                <Link to="/signup">
                                                    <div className="flex flex-col items-center space-y-1">
                                                        <p className="text-blue-600 font-semibold text-sm">Create Account</p>
                                                        <span className="text-[13px] font-medium text-gray-500 text-center">UK Logistics</span>
                                                    </div>
                                                </Link>
                                            </>}
                                    </div>
                                </div>
                                <Dialog open={openSideMenu} onClose={setOpenSideMenu} className="relative z-50">
                                    <div
                                        transition
                                        className="fixed inset-0 bg-black bg-opacity-65 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
                                    />

                                    <div className="fixed inset-0 overflow-hidden">
                                        <div className="absolute inset-0 overflow-hidden">
                                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                                <DialogPanel
                                                    transition
                                                    className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700"
                                                >
                                                    <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                                        <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                                            <div className="flex items-start justify-between">
                                                                <DialogTitle className="text-lg sm:text-xl font-bold text-gray-900 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                                                    <span>Wallet Recharge</span>

                                                                    {/* Refresh Button */}
                                                                    <button
                                                                        onClick={() => window.location.reload()}
                                                                        className="flex items-center justify-center font-normal gap-2 text-xs sm:text-sm px-4 py-0.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                                                    >
                                                                        <FaSyncAlt /> Refresh
                                                                    </button>
                                                                </DialogTitle>

                                                                <div className="ml-3 flex h-7 items-center">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => setOpenSideMenu(false)}
                                                                        className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                                                    >
                                                                        <span className="absolute -inset-0.5" />
                                                                        <span className="sr-only">Close panel</span>
                                                                        <IoClose aria-hidden="true" className="size-6" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <form onSubmit={formik.handleSubmit}>
                                                                {/* <h2 className="text-lg font-semibold text-gray-800">Upgrade Your Shipping Limit</h2> */}

                                                                {/* <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4"> */}

                                                                {/* </div> */}
                                                                <div className='p-4 mt-4 bg-slate-50 rounded-md'>
                                                                    <p className="font-semibold text-slate-800 mt-1">Enter the amount for your recharge</p>

                                                                    {/* Input Field */}
                                                                    <div className="mt-2 mb-4">
                                                                        <input
                                                                            type="number"
                                                                            name="amount"
                                                                            className="w-full px-4 py-2 rounded-lg border border-slate-400 text-sm"
                                                                            value={formik.values.amount}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            placeholder='Enter Amount'
                                                                        />
                                                                        <p className='text-xs text-slate-600 mt-1'>Min value:₹1</p>
                                                                        {formik.touched.amount && formik.errors.amount ? (
                                                                            <p className="text-red-500 text-sm mt-1">{formik.errors.amount}</p>
                                                                        ) : null}
                                                                    </div>

                                                                    {/* Quick Select Buttons */}
                                                                    <p className='text-sm text-slate-600 font-semibold'>Or Select From Below</p>
                                                                    <div className="flex flex-wrap gap-2 mt-2">
                                                                        {amounts.map((amt) => (
                                                                            <p
                                                                                key={amt}
                                                                                className={`px-4 py-2 text-sm bg-white border rounded-lg hover:bg-slate-800 hover:text-white cursor-pointer transition ${formik.values.amount == amt ? "bg-slate-800 text-black" : "text-gray-800"
                                                                                    }`}
                                                                                onClick={() => formik.setFieldValue("amount", amt)}
                                                                            >
                                                                                {amt}
                                                                            </p>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                {/* Submit Button */}
                                                                <div className="mt-6">
                                                                    <button
                                                                        type="submit"
                                                                        className="w-full bg-slate-800 text-white text-center py-2 rounded-lg cursor-pointer hover:bg-slate-900 transition"
                                                                    >
                                                                        Recharge
                                                                    </button>
                                                                </div>

                                                                {/* Alternative Recharge Option */}
                                                                <div className="mt-4 text-center relative">
                                                                    {/* Button */}
                                                                    <button
                                                                        className="w-full text-sm px-4 py-2 border border-gray-400 rounded-lg text-gray-500 bg-gray-200 cursor-not-allowed relative transition"
                                                                        disabled
                                                                        onMouseEnter={() => setShowTooltip(true)}
                                                                        onMouseLeave={() => setShowTooltip(false)}
                                                                    >
                                                                        Recharge from Remittance
                                                                    </button>

                                                                    {/* Tooltip */}
                                                                    {showTooltip && (
                                                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-max bg-gray-900 text-white text-xs rounded-md px-3 py-1 shadow-lg">
                                                                            Feature not available
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div className="flex justify-center items-center mt-5">
                                                                    <Link to="/wallettransactions" className="block w-full max-w-sm">
                                                                        <div className="border-y flex items-center justify-between  hover:bg-slate-100 border-slate-200 px-4 py-3 text-center">
                                                                            <h2 className="font-semibold text-sm text-slate-800">Current Wallet Amount</h2>
                                                                            <div className="flex items-center gap-2">
                                                                                <span className="font-semibold text-sm text-green-600">
                                                                                    ₹ {walletData?.GetWalletBalanceAmount?.balance
                                                                                        ? Number(walletData?.GetWalletBalanceAmount?.balance).toFixed(2)
                                                                                        : "0.00"}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </form>


                                                        </div>

                                                        {/* <div className="border-t border-gray-200 px-4 py-6 sm:px-6">

                                                            <p className='text-sm'>Note: Currently, DTDC accepts UPI payments from savings and current accounts. UPI payments from RuPay credit cards and Prepaid Payment Instruments (PPIs) are not accepted.</p>

                                                        </div> */}
                                                        <div className="border-t bg-slate-50 border-gray-200 px-4 py-6 sm:px-6">
                                                            <p className='text-sm font-semibold text-center'>Upgrade Your Shipping Limit</p>
                                                        </div>
                                                    </div>
                                                </DialogPanel>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog>

                                <div className="relative ml-8 lg:ml-8 lg:flex cursor-pointer">
                                    <div className="flow-root" onClick={DropdownCouriers}>
                                        <div className="group -m-2 flex lg:flex-col items-center p-2">
                                            <PiBoxArrowUp
                                                className="h-7 w-7 flex-shrink-0 text-gray-600 group-hover:text-gray-700"
                                                aria-hidden="true"
                                            />
                                            <div className='flex'>
                                                <span className="ml-1 text-sm font-medium text-gray-700 group-hover:text-gray-800">All Shipment</span>
                                                <IoCaretDown className='md:mt-1' />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div
                                        className="flex items-center text-gray-700 hover:text-gray-800 relative"
                                        onClick={toggleDropdown} // Toggle dropdown on click
                                    >
                                          <PiBoxArrowUp
                                            className="h-7 w-7 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                                            aria-hidden="true"
                                        />
                                        <span className="ml-1 block text-sm font-medium">All Courier
                                        </span><IoCaretDown className='mt-1' />
                                    </div> */}

                                    {/* Dropdown */}
                                    {isOpenAllCourier && (
                                        <div className="absolute right-0 top-6 lg:top-9 mt-5 w-52 bg-white border border-gray-300 rounded-md shadow-lg z-50">
                                            <ul className="py-2">
                                                <li>
                                                    <Link
                                                        to="/dashboard"
                                                        state={{ data: 'All Courier' }}
                                                        className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    >
                                                        <BsBox className="text-xl me-2 ms-0.5 text-slate-600" />
                                                        India's Shipment
                                                    </Link>
                                                </li>

                                                {/* <li>
                                                    <Link
                                                        to="/bikeallorder"
                                                        className="flex items-center px-4 py-2 mt-1 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    >
                                                        <MdDirectionsBike className="text-xl me-2 text-slate-600" />
                                                        Two-Wheeler Parcel
                                                    </Link>
                                                </li> */}

                                                <li>
                                                    <Link
                                                        to={false ? "/internationalAllOrders" : null} // Replace 'false' with your condition to enable
                                                        className={`flex items-center px-4 pb-2 pt-1.5 text-sm font-medium ${false ? "text-gray-700 hover:bg-slate-100" : "text-gray-400 cursor-not-allowed"
                                                            }`}
                                                        onClick={(e) => false && e.preventDefault()} // Prevent click when disabled
                                                    >
                                                        <LuPlaneTakeoff className={`text-2xl me-2 ${false ? "text-slate-600" : "text-gray-400"}`} />
                                                        Global Shipment
                                                    </Link>
                                                </li>
                                                {/* <li>
                                                    <Link
                                                        to="/foreignair"
                                                        className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-100"
                                                    >
                                                        International Courier
                                                    </Link>
                                                </li> */}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            <Dialog open={openPincode} onClose={closeEventData} className="relative z-50">
                <div
                    transition
                    className="fixed inset-0 bg-black bg-opacity-65 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
                >
                </div>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700"
                            >

                                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                    <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                        <div className="flex mb-6 items-start justify-between">
                                            <DialogTitle className="text-lg font-bold text-gray-900">Available Pincode </DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <button
                                                    type="button"
                                                    onClick={() => setOpenPincode(false)}
                                                    className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                                >
                                                    <span className="absolute -inset-0.5" />
                                                    <span className="sr-only">Close panel</span>
                                                    <IoClose aria-hidden="true" className="size-6" />
                                                </button>
                                            </div>
                                        </div>
                                        {message && (
                                            <div className={`flex items-center gap-2 mb-4 font-semibold ${message === 'Pincode Service Available' ? 'text-green-500' : 'text-red-500'}`}>
                                                {message === 'Pincode Service Available' ? (
                                                    <FaCheckCircle className="w-5 h-5 text-green-500" />
                                                ) : (
                                                    <FaTimesCircle className="w-5 h-5 text-red-500" />
                                                )}
                                                <p>{message}</p>
                                            </div>
                                        )}
                                        <div>
                                            <Formik
                                                initialValues={initialValues}
                                                validationSchema={validationSchema}
                                                onSubmit={(values, { setSubmitting }) => {
                                                    onSubmit(values);
                                                    setSubmitting(false);
                                                }}
                                            >
                                                {({ isSubmitting, setFieldValue }) => (
                                                    <Form className="space-y-4">
                                                        <div>
                                                            <label htmlFor="origin" className="block text-sm font-medium text-gray-700">
                                                                Pickup Pincode <span className="text-red-500">*</span>
                                                            </label>
                                                            <Field
                                                                type="text"
                                                                id="origin"
                                                                name="origin"
                                                                placeholder="Enter pickup pincode"
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setFieldValue('origin', value);
                                                                }}
                                                                className="mt-2 block w-full px-3 py-2 border focus:outline-none focus:ring-slate-600 focus:border-slate-600 border-slate-400 rounded-md"
                                                            />
                                                            <ErrorMessage name="origin" component="div" className="text-red-500 text-sm" />
                                                        </div>

                                                        <div>
                                                            <label htmlFor="destination" className="block text-sm font-medium text-gray-700">
                                                                Delivery Pincode <span className="text-red-500">*</span>
                                                            </label>
                                                            <Field
                                                                type="text"
                                                                id="destination"
                                                                name="destination"
                                                                placeholder="Enter delivery pincode"
                                                                className="mt-2 block w-full px-3 py-2 border focus:outline-none focus:ring-slate-600 focus:border-slate-600 border-slate-400 rounded-md"
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setFieldValue('destination', value);
                                                                }}
                                                            />
                                                            <ErrorMessage name="destination" component="div" className="text-red-500 text-sm" />
                                                        </div>
                                                        <div className="flex justify-end">
                                                            <button
                                                                type="submit"
                                                                className="px-4 py-2 mt-3 bg-slate-900 w-full font-medium text-white rounded-lg flex justify-center items-center"
                                                                disabled={isLoading}
                                                            >
                                                                {isLoading ? (
                                                                    <div className='flex justify-center items-center'>
                                                                        <span className='mr-2'>Loading...</span>
                                                                        <SpinLoader />
                                                                    </div>
                                                                ) : (
                                                                    'Check Pincode'
                                                                )}
                                                            </button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>


                                    </div>
                                </div>
                                <div className="sticky text-sm bottom-0 bg-slate-100 px-4 py-3 sm:px-6 rounded-b-lg">
                                    <p>Enter your pincode to verify service availability and shipping options for your location.</p>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div >
    )
}

export default Header
